module.exports = {
    countries: [
      {
        ID: 'CON00001',
        name: 'Afghanistan',
      },
      {
        ID: 'CON00002',
        name: 'Albania',
      },
      {
        ID: 'CON00003',
        name: 'Algeria',
      },
      {
        ID: 'CON00004',
        name: 'American Samoa',
      },
      {
        ID: 'CON00005',
        name: 'Andorra',
      },
      {
        ID: 'CON00006',
        name: 'Angola',
      },
      {
        ID: 'CON00007',
        name: 'Anguilla',
      },
      {
        ID: 'CON00008',
        name: 'Antarctica',
      },
      {
        ID: 'CON00009',
        name: 'Antigua and Barbuda',
      },
      {
        ID: 'CON00010',
        name: 'Argentina',
      },
      {
        ID: 'CON00011',
        name: 'Armenia',
      },
      {
        ID: 'CON00012',
        name: 'Aruba',
      },
      {
        ID: 'CON00013',
        name: 'Australia',
      },
      {
        ID: 'CON00014',
        name: 'Austria',
      },
      {
        ID: 'CON00015',
        name: 'Azerbaijan',
      },
      {
        ID: 'CON00016',
        name: 'Bahamas (the)',
      },
      {
        ID: 'CON00017',
        name: 'Bahrain',
      },
      {
        ID: 'CON00018',
        name: 'Bangladesh',
      },
      {
        ID: 'CON00019',
        name: 'Barbados',
      },
      {
        ID: 'CON00020',
        name: 'Belarus',
      },
      {
        ID: 'CON00021',
        name: 'Belgium',
      },
      {
        ID: 'CON00022',
        name: 'Belize',
      },
      {
        ID: 'CON00023',
        name: 'Benin',
      },
      {
        ID: 'CON00024',
        name: 'Bermuda',
      },
      {
        ID: 'CON00025',
        name: 'Bhutan',
      },
      {
        ID: 'CON00026',
        name: 'Bolivia (Plurinational State of)',
      },
      {
        ID: 'CON00027',
        name: 'Bonaire, Sint Eustatius and Saba',
      },
      {
        ID: 'CON00028',
        name: 'Bosnia and Herzegovina',
      },
      {
        ID: 'CON00029',
        name: 'Botswana',
      },
      {
        ID: 'CON00030',
        name: 'Bouvet Island',
      },
      {
        ID: 'CON00031',
        name: 'Brazil',
      },
      {
        ID: 'CON00032',
        name: 'British Indian Ocean Territory (the)',
      },
      {
        ID: 'CON00033',
        name: 'Brunei Darussalam',
      },
      {
        ID: 'CON00034',
        name: 'Bulgaria',
      },
      {
        ID: 'CON00035',
        name: 'Burkina Faso',
      },
      {
        ID: 'CON00036',
        name: 'Burundi',
      },
      {
        ID: 'CON00037',
        name: 'Cabo Verde',
      },
      {
        ID: 'CON00038',
        name: 'Cambodia',
      },
      {
        ID: 'CON00039',
        name: 'Cameroon',
      },
      {
        ID: 'CON00040',
        name: 'Canada',
      },
      {
        ID: 'CON00041',
        name: 'Cayman Islands (the)',
      },
      {
        ID: 'CON00042',
        name: 'Central African Republic (the)',
      },
      {
        ID: 'CON00043',
        name: 'Chad',
      },
      {
        ID: 'CON00044',
        name: 'Chile',
      },
      {
        ID: 'CON00045',
        name: 'China',
      },
      {
        ID: 'CON00046',
        name: 'Christmas Island',
      },
      {
        ID: 'CON00047',
        name: 'Cocos (Keeling) Islands (the)',
      },
      {
        ID: 'CON00048',
        name: 'Colombia',
      },
      {
        ID: 'CON00049',
        name: 'Comoros (the)',
      },
      {
        ID: 'CON00050',
        name: 'Congo (the Democratic Republic of the)',
      },
      {
        ID: 'CON00051',
        name: 'Congo (the)',
      },
      {
        ID: 'CON00052',
        name: 'Cook Islands (the)',
      },
      {
        ID: 'CON00053',
        name: 'Costa Rica',
      },
      {
        ID: 'CON00054',
        name: 'Croatia',
      },
      {
        ID: 'CON00055',
        name: 'Cuba',
      },
      {
        ID: 'CON00056',
        name: 'Curaçao',
      },
      {
        ID: 'CON00057',
        name: 'Cyprus',
      },
      {
        ID: 'CON00058',
        name: 'Czechia',
      },
      {
        ID: 'CON00059',
        name: "Côte d'Ivoire",
      },
      {
        ID: 'CON00060',
        name: 'Denmark',
      },
      {
        ID: 'CON00061',
        name: 'Djibouti',
      },
      {
        ID: 'CON00062',
        name: 'Dominica',
      },
      {
        ID: 'CON00063',
        name: 'Dominican Republic (the)',
      },
      {
        ID: 'CON00064',
        name: 'Ecuador',
      },
      {
        ID: 'CON00065',
        name: 'Egypt',
      },
      {
        ID: 'CON00066',
        name: 'El Salvador',
      },
      {
        ID: 'CON00067',
        name: 'Equatorial Guinea',
      },
      {
        ID: 'CON00068',
        name: 'Eritrea',
      },
      {
        ID: 'CON00069',
        name: 'Estonia',
      },
      {
        ID: 'CON00070',
        name: 'Eswatini',
      },
      {
        ID: 'CON00071',
        name: 'Ethiopia',
      },
      {
        ID: 'CON00072',
        name: 'Falkland Islands (the) [Malvinas]',
      },
      {
        ID: 'CON00073',
        name: 'Faroe Islands (the)',
      },
      {
        ID: 'CON00074',
        name: 'Fiji',
      },
      {
        ID: 'CON00075',
        name: 'Finland',
      },
      {
        ID: 'CON00076',
        name: 'France',
      },
      {
        ID: 'CON00077',
        name: 'French Guiana',
      },
      {
        ID: 'CON00078',
        name: 'French Polynesia',
      },
      {
        ID: 'CON00079',
        name: 'French Southern Territories (the)',
      },
      {
        ID: 'CON00080',
        name: 'Gabon',
      },
      {
        ID: 'CON00081',
        name: 'Gambia (the)',
      },
      {
        ID: 'CON00082',
        name: 'Georgia',
      },
      {
        ID: 'CON00083',
        name: 'Germany',
      },
      {
        ID: 'CON00084',
        name: 'Ghana',
      },
      {
        ID: 'CON00085',
        name: 'Gibraltar',
      },
      {
        ID: 'CON00086',
        name: 'Greece',
      },
      {
        ID: 'CON00087',
        name: 'Greenland',
      },
      {
        ID: 'CON00088',
        name: 'Grenada',
      },
      {
        ID: 'CON00089',
        name: 'Guadeloupe',
      },
      {
        ID: 'CON00090',
        name: 'Guam',
      },
      {
        ID: 'CON00091',
        name: 'Guatemala',
      },
      {
        ID: 'CON00092',
        name: 'Guernsey',
      },
      {
        ID: 'CON00093',
        name: 'Guinea',
      },
      {
        ID: 'CON00094',
        name: 'Guinea-Bissau',
      },
      {
        ID: 'CON00095',
        name: 'Guyana',
      },
      {
        ID: 'CON00096',
        name: 'Haiti',
      },
      {
        ID: 'CON00097',
        name: 'Heard Island and McDonald Islands',
      },
      {
        ID: 'CON00098',
        name: 'Holy See (the)',
      },
      {
        ID: 'CON00099',
        name: 'Honduras',
      },
      {
        ID: 'CON00100',
        name: 'Hong Kong',
      },
      {
        ID: 'CON00101',
        name: 'Hungary',
      },
      {
        ID: 'CON00102',
        name: 'Iceland',
      },
      {
        ID: 'CON00103',
        name: 'India',
      },
      {
        ID: 'CON00104',
        name: 'Indonesia',
      },
      {
        ID: 'CON00105',
        name: 'Iran (Islamic Republic of)',
      },
      {
        ID: 'CON00106',
        name: 'Iraq',
      },
      {
        ID: 'CON00107',
        name: 'Ireland',
      },
      {
        ID: 'CON00108',
        name: 'Isle of Man',
      },
      {
        ID: 'CON00109',
        name: 'Israel',
      },
      {
        ID: 'CON00110',
        name: 'Italy',
      },
      {
        ID: 'CON00111',
        name: 'Jamaica',
      },
      {
        ID: 'CON00112',
        name: 'Japan',
      },
      {
        ID: 'CON00113',
        name: 'Jersey',
      },
      {
        ID: 'CON00114',
        name: 'Jordan',
      },
      {
        ID: 'CON00115',
        name: 'Kazakhstan',
      },
      {
        ID: 'CON00116',
        name: 'Kenya',
      },
      {
        ID: 'CON00117',
        name: 'Kiribati',
      },
      {
        ID: 'CON00118',
        name: "Korea (the Democratic People's Republic of)",
      },
      {
        ID: 'CON00119',
        name: 'Korea (the Republic of)',
      },
      {
        ID: 'CON00120',
        name: 'Kuwait',
      },
      {
        ID: 'CON00121',
        name: 'Kyrgyzstan',
      },
      {
        ID: 'CON00122',
        name: "Lao People's Democratic Republic (the)",
      },
      {
        ID: 'CON00123',
        name: 'Latvia',
      },
      {
        ID: 'CON00124',
        name: 'Lebanon',
      },
      {
        ID: 'CON00125',
        name: 'Lesotho',
      },
      {
        ID: 'CON00126',
        name: 'Liberia',
      },
      {
        ID: 'CON00127',
        name: 'Libya',
      },
      {
        ID: 'CON00128',
        name: 'Liechtenstein',
      },
      {
        ID: 'CON00129',
        name: 'Lithuania',
      },
      {
        ID: 'CON00130',
        name: 'Luxembourg',
      },
      {
        ID: 'CON00131',
        name: 'Macao',
      },
      {
        ID: 'CON00132',
        name: 'Madagascar',
      },
      {
        ID: 'CON00133',
        name: 'Malawi',
      },
      {
        ID: 'CON00134',
        name: 'Malaysia',
      },
      {
        ID: 'CON00135',
        name: 'Maldives',
      },
      {
        ID: 'CON00136',
        name: 'Mali',
      },
      {
        ID: 'CON00137',
        name: 'Malta',
      },
      {
        ID: 'CON00138',
        name: 'Marshall Islands (the)',
      },
      {
        ID: 'CON00139',
        name: 'Martinique',
      },
      {
        ID: 'CON00140',
        name: 'Mauritania',
      },
      {
        ID: 'CON00141',
        name: 'Mauritius',
      },
      {
        ID: 'CON00142',
        name: 'Mayotte',
      },
      {
        ID: 'CON00143',
        name: 'Mexico',
      },
      {
        ID: 'CON00144',
        name: 'Micronesia (Federated States of)',
      },
      {
        ID: 'CON00145',
        name: 'Moldova (the Republic of)',
      },
      {
        ID: 'CON00146',
        name: 'Monaco',
      },
      {
        ID: 'CON00147',
        name: 'Mongolia',
      },
      {
        ID: 'CON00148',
        name: 'Montenegro',
      },
      {
        ID: 'CON00149',
        name: 'Montserrat',
      },
      {
        ID: 'CON00150',
        name: 'Morocco',
      },
      {
        ID: 'CON00151',
        name: 'Mozambique',
      },
      {
        ID: 'CON00152',
        name: 'Myanmar',
      },
      {
        ID: 'CON00153',
        name: 'Namibia',
      },
      {
        ID: 'CON00154',
        name: 'Nauru',
      },
      {
        ID: 'CON00155',
        name: 'Nepal',
      },
      {
        ID: 'CON00156',
        name: 'Netherlands (the)',
      },
      {
        ID: 'CON00157',
        name: 'New Caledonia',
      },
      {
        ID: 'CON00158',
        name: 'New Zealand',
      },
      {
        ID: 'CON00159',
        name: 'Nicaragua',
      },
      {
        ID: 'CON00160',
        name: 'Niger (the)',
      },
      {
        ID: 'CON00161',
        name: 'Nigeria',
      },
      {
        ID: 'CON00162',
        name: 'Niue',
      },
      {
        ID: 'CON00163',
        name: 'Norfolk Island',
      },
      {
        ID: 'CON00164',
        name: 'Northern Mariana Islands (the)',
      },
      {
        ID: 'CON00165',
        name: 'Norway',
      },
      {
        ID: 'CON00166',
        name: 'Oman',
      },
      {
        ID: 'CON00167',
        name: 'Pakistan',
      },
      {
        ID: 'CON00168',
        name: 'Palau',
      },
      {
        ID: 'CON00169',
        name: 'Palestine, State of',
      },
      {
        ID: 'CON00170',
        name: 'Panama',
      },
      {
        ID: 'CON00171',
        name: 'Papua New Guinea',
      },
      {
        ID: 'CON00172',
        name: 'Paraguay',
      },
      {
        ID: 'CON00173',
        name: 'Peru',
      },
      {
        ID: 'CON00174',
        name: 'Philippines (the)',
      },
      {
        ID: 'CON00175',
        name: 'Pitcairn',
      },
      {
        ID: 'CON00176',
        name: 'Poland',
      },
      {
        ID: 'CON00177',
        name: 'Portugal',
      },
      {
        ID: 'CON00178',
        name: 'Puerto Rico',
      },
      {
        ID: 'CON00179',
        name: 'Qatar',
      },
      {
        ID: 'CON00180',
        name: 'Republic of North Macedonia',
      },
      {
        ID: 'CON00181',
        name: 'Romania',
      },
      {
        ID: 'CON00182',
        name: 'Russian Federation (the)',
      },
      {
        ID: 'CON00183',
        name: 'Rwanda',
      },
      {
        ID: 'CON00184',
        name: 'Réunion',
      },
      {
        ID: 'CON00185',
        name: 'Saint Barthélemy',
      },
      {
        ID: 'CON00186',
        name: 'Saint Helena, Ascension and Tristan da Cunha',
      },
      {
        ID: 'CON00187',
        name: 'Saint Kitts and Nevis',
      },
      {
        ID: 'CON00188',
        name: 'Saint Lucia',
      },
      {
        ID: 'CON00189',
        name: 'Saint Martin (French part)',
      },
      {
        ID: 'CON00190',
        name: 'Saint Pierre and Miquelon',
      },
      {
        ID: 'CON00191',
        name: 'Saint Vincent and the Grenadines',
      },
      {
        ID: 'CON00192',
        name: 'Samoa',
      },
      {
        ID: 'CON00193',
        name: 'San Marino',
      },
      {
        ID: 'CON00194',
        name: 'Sao Tome and Principe',
      },
      {
        ID: 'CON00195',
        name: 'Saudi Arabia',
      },
      {
        ID: 'CON00196',
        name: 'Senegal',
      },
      {
        ID: 'CON00197',
        name: 'Serbia',
      },
      {
        ID: 'CON00198',
        name: 'Seychelles',
      },
      {
        ID: 'CON00199',
        name: 'Sierra Leone',
      },
      {
        ID: 'CON00200',
        name: 'Singapore',
      },
      {
        ID: 'CON00201',
        name: 'Sint Maarten (Dutch part)',
      },
      {
        ID: 'CON00202',
        name: 'Slovakia',
      },
      {
        ID: 'CON00203',
        name: 'Slovenia',
      },
      {
        ID: 'CON00204',
        name: 'Solomon Islands',
      },
      {
        ID: 'CON00205',
        name: 'Somalia',
      },
      {
        ID: 'CON00206',
        name: 'South Africa',
      },
      {
        ID: 'CON00207',
        name: 'South Georgia and the South Sandwich Islands',
      },
      {
        ID: 'CON00208',
        name: 'South Sudan',
      },
      {
        ID: 'CON00209',
        name: 'Spain',
      },
      {
        ID: 'CON00210',
        name: 'Sri Lanka',
      },
      {
        ID: 'CON00211',
        name: 'Sudan (the)',
      },
      {
        ID: 'CON00212',
        name: 'Suriname',
      },
      {
        ID: 'CON00213',
        name: 'Svalbard and Jan Mayen',
      },
      {
        ID: 'CON00214',
        name: 'Sweden',
      },
      {
        ID: 'CON00215',
        name: 'Switzerland',
      },
      {
        ID: 'CON00216',
        name: 'Syrian Arab Republic',
      },
      {
        ID: 'CON00217',
        name: 'Taiwan',
      },
      {
        ID: 'CON00218',
        name: 'Tajikistan',
      },
      {
        ID: 'CON00219',
        name: 'Tanzania, United Republic of',
      },
      {
        ID: 'CON00220',
        name: 'Thailand',
      },
      {
        ID: 'CON00221',
        name: 'Timor-Leste',
      },
      {
        ID: 'CON00222',
        name: 'Togo',
      },
      {
        ID: 'CON00223',
        name: 'Tokelau',
      },
      {
        ID: 'CON00224',
        name: 'Tonga',
      },
      {
        ID: 'CON00225',
        name: 'Trinidad and Tobago',
      },
      {
        ID: 'CON00226',
        name: 'Tunisia',
      },
      {
        ID: 'CON00227',
        name: 'Turkey',
      },
      {
        ID: 'CON00228',
        name: 'Turkmenistan',
      },
      {
        ID: 'CON00229',
        name: 'Turks and Caicos Islands (the)',
      },
      {
        ID: 'CON00230',
        name: 'Tuvalu',
      },
      {
        ID: 'CON00231',
        name: 'Uganda',
      },
      {
        ID: 'CON00232',
        name: 'Ukraine',
      },
      {
        ID: 'CON00233',
        name: 'United Arab Emirates (the)',
      },
      {
        ID: 'CON00234',
        name: 'United Kingdom of Great Britain and Northern Ireland (the)',
      },
      {
        ID: 'CON00235',
        name: 'United States Minor Outlying Islands (the)',
      },
      {
        ID: 'CON00236',
        name: 'United States of America (the)',
      },
      {
        ID: 'CON00237',
        name: 'Uruguay',
      },
      {
        ID: 'CON00238',
        name: 'Uzbekistan',
      },
      {
        ID: 'CON00239',
        name: 'Vanuatu',
      },
      {
        ID: 'CON00240',
        name: 'Venezuela (Bolivarian Republic of)',
      },
      {
        ID: 'CON00241',
        name: 'Viet Nam',
      },
      {
        ID: 'CON00242',
        name: 'Virgin Islands (British)',
      },
      {
        ID: 'CON00243',
        name: 'Virgin Islands (U.S.)',
      },
      {
        ID: 'CON00244',
        name: 'Wallis and Futuna',
      },
      {
        ID: 'CON00245',
        name: 'Western Sahara',
      },
      {
        ID: 'CON00246',
        name: 'Yemen',
      },
      {
        ID: 'CON00247',
        name: 'Zambia',
      },
      {
        ID: 'CON00248',
        name: 'Zimbabwe',
      },
      {
        ID: 'CON00249',
        name: 'Åland Islands',
      },
    ],
  };
  